import { NotificationT } from 'lib-shared-legacy-types';

import RatingNotification from './RatingNotification';
import { NotificationToaster } from './notification';

import '../style/notification.less';

type NotificationsListProps = {
  currentNotifications: Array<NotificationT>;
  ratingNotificaions: Array<NotificationT>;
  notificationRemoveById: (payload: { id: string }) => void;
  dispatch: () => void;
};

const NotificationsList = ({
  currentNotifications = [],
  ratingNotificaions = [],
  dispatch,
  notificationRemoveById,
}: NotificationsListProps) => {
  const renderNotification = (notification: NotificationT) => {
    if (
      notification.type === 'rating-up' ||
      notification.type === 'rating-down'
    ) {
      return (
        <RatingNotification
          key={notification.id}
          dispatch={dispatch}
          notificationRemoveById={notificationRemoveById}
          notification={notification}
        />
      );
    }
    return (
      <NotificationToaster
        key={notification.id}
        dispatch={dispatch}
        notificationRemoveById={notificationRemoveById}
        notification={notification}
      />
    );
  };

  return (
    <div id="alerts-holder">
      {currentNotifications.map(renderNotification)}
      {ratingNotificaions.map(renderNotification)}
    </div>
  );
};

export default NotificationsList;
